import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { act } from "@/lib/hooks";
import { api } from "@/lib/api";
import { Field, NativeSelect } from "@/components/common";

// target: { lead_id } | { opportunity_id } | null (free choice of customer)
export function ActivityDialog({ open, onClose, onSaved, target, customers = [] }) {
  const [f, setF] = useState({ type: "call", subject: "", due_at: "", customer_id: "", notes: "" });
  const save = async () => {
    const body = { ...f, ...(target || {}), customer_id: f.customer_id || null, due_at: f.due_at || null };
    if (await act(() => api.post("/crm/activities", body), "Activity logged")) { setF({ type: "call", subject: "", due_at: "", customer_id: "", notes: "" }); onSaved(); onClose(); }
  };
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent data-testid="activity-dialog" className="max-h-[90vh] overflow-y-auto">
        <DialogHeader><DialogTitle>Log activity</DialogTitle><DialogDescription className="sr-only">Record a call, meeting, email or note for this record.</DialogDescription></DialogHeader>
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <Field label="Type"><NativeSelect testId="activity-type-select" className="w-full" value={f.type} onChange={(v) => setF({ ...f, type: v })} options={["call", "meeting", "task", "reminder"].map((x) => ({ value: x, label: x }))} /></Field>
            <Field label="Due"><Input type="datetime-local" data-testid="activity-due-input" value={f.due_at} onChange={(e) => setF({ ...f, due_at: e.target.value })} /></Field>
          </div>
          <Field label="Subject"><Input data-testid="activity-subject-input" value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} /></Field>
          {!target && <Field label="Customer"><NativeSelect testId="activity-customer-select" className="w-full" value={f.customer_id} onChange={(v) => setF({ ...f, customer_id: v })} placeholder="None" options={customers.map((c) => ({ value: c.id, label: c.name }))} /></Field>}
          <Field label="Notes"><Textarea data-testid="activity-notes-input" value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} /></Field>
        </div>
        <DialogFooter><Button data-testid="activity-save-button" disabled={!f.subject} onClick={save}>Save</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
